import { isAfter } from 'date-fns/isAfter';
import { isBefore } from 'date-fns/isBefore';
import { isValid } from 'date-fns/isValid';
import { parse } from 'date-fns/parse';
import { startOfDay } from 'date-fns/startOfDay';

import { getZonedDate, ZonedDate } from '@eika-infrastruktur/date';

import { DateInputErrors } from '../DateInputTypes';

export const dateErrorMessages: DateInputErrors = {
    invalid: 'Oppgi en gyldig dato',
    required: 'Oppgi en gyldig dato',
    outOfRangeMax: 'Datoen du har valgt er for langt frem i tid',
    outOfRangeMin: 'Datoen du har valgt er for langt tilbake i tid',
};

export const parseDateInput = (date: string, format: string): Date => {
    return parse(date.replace(/(\/)|(\s)|(-)/g, '.'), format, new Date());
};

export const validateDate = (date: string, format: string): boolean => {
    try {
        const parsedDate = parseDateInput(date, format);
        const year = parsedDate.getFullYear();
        return isValid(parsedDate) && year > 999 && year < 9999;
    } catch (e) {
        return false;
    }
};

export const validateDateRange = (
    date: ZonedDate,
    minDate?: ZonedDate,
    maxDate?: ZonedDate,
    errorMessages: DateInputErrors = dateErrorMessages,
    ignoreTime = true,
): string | undefined => {
    if (ignoreTime) {
        date = getZonedDate(startOfDay(date));
    }

    if (maxDate && isAfter(date, getZonedDate(startOfDay(maxDate)))) {
        return errorMessages.outOfRangeMax;
    }

    if (minDate && isBefore(date, getZonedDate(startOfDay(minDate)))) {
        return errorMessages.outOfRangeMin;
    }
    return undefined;
};
